import React, { useState } from "react";
import axios from "axios";
import ReactModal from "react-modal";
import { TextField } from "@mui/material";
import moment from "moment-timezone";

function AgregarVisitaEvaluador(props) {
  const [modalIsOpen, setIsOpen] = useState(false);

  const [value, setValue] = useState("");
  const [value1, setValue1] = useState("");
  const [postObjetivo, setPostObjetivo] = useState("");
  const [postActividad, setPostActividad] = useState("");
  const [postObservaciones, setPostObservaciones] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOpenModalTest = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  moment.tz.setDefault("America/New_York");

  const postData = async (e) => {
    e.preventDefault();

    if (!postObjetivo || !postActividad || !value || !value1) {
      alert("Por favor complete todos los campos obligatorios");
      return;
    }

    try {
      setLoading(true);

      const response = await axios({
        method: "post",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: "https://suadesarrollo.azurewebsites.net/api/CreaVisitaEvaluador",
        data: {
          Objetivo: postObjetivo,
          Actividad: postActividad,
          Observaciones: postObservaciones,
          FechaInicial: value,
          FechaFinal: value1,
          Asignar: "",
          Tipo: "Agenda",
          EvaluadorId: props.idE,
          SolicitudId: props.idS,
          Estado: "1",
        },
      });

      console.log(response.data);
      alert("Evento creado con éxito ✅");

      closeModal();

      // 🔥 Notifica al componente padre para refrescar la lista
      if (props.onSuccess) {
        props.onSuccess();
      }

      // Limpia el formulario
      setPostObjetivo("");
      setPostActividad("");
      setPostObservaciones("");
      setValue("");
      setValue1("");
    } catch (error) {
      console.error(error);
      alert("Error al crear el evento");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button className="btn btn-primary" onClick={handleOpenModalTest}>
        Añadir evento
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
        contentLabel="Agregar visita"
      >
        <div className="container">
          <div className="card shadow">
            <div className="card-header text-primary font-weight-bold">
              Agregar visita / evento
            </div>

            <div className="card-body">
              <form className="user">
                <div className="form-group row">
                  <div className="col-sm-6 mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Objetivo"
                      value={postObjetivo}
                      onChange={(e) => setPostObjetivo(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Actividad"
                      value={postActividad}
                      onChange={(e) => setPostActividad(e.target.value)}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Observaciones"
                    value={postObservaciones}
                    onChange={(e) => setPostObservaciones(e.target.value)}
                  />
                </div>

                <div className="form-group row">
                  <div className="col-sm-6 mb-3">
                    <TextField
                      fullWidth
                      label="Hora Inicial"
                      type="datetime-local"
                      InputLabelProps={{ shrink: true }}
                      value={value}
                      onChange={(e) => setValue(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-6">
                    <TextField
                      fullWidth
                      label="Hora Final"
                      type="datetime-local"
                      InputLabelProps={{ shrink: true }}
                      value={value1}
                      onChange={(e) => setValue1(e.target.value)}
                    />
                  </div>
                </div>

                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={postData}
                  disabled={loading}
                >
                  {loading ? "Guardando..." : "Guardar"}
                </button>

                <button
                  type="button"
                  className="btn btn-secondary btn-block mt-2"
                  onClick={closeModal}
                >
                  Cancelar
                </button>
              </form>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default AgregarVisitaEvaluador;
